import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/base/SectionHeading";
import ContactForm from "./components/ContactForm";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useReveal } from "@/hooks/useReveal";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于萌妖图鉴",
    description: "萌妖图鉴是韩国妖精漫画角色资料整理与爱好者交流平台，专注女主颜值与人设、萌娘属性、CP组合盘点。",
  },
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "联系我们",
    description: "投稿韩国妖精漫画角色资料、纠错或合作交流，可通过萌妖图鉴投稿表单与我们联系。",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://mangami2.github.io/" },
      { "@type": "ListItem", position: 2, name: "关于我们", item: "https://mangami2.github.io/about" },
    ],
  },
];

const values = [
  { icon: "ri-focus-3-line", title: "客观中立", desc: "角色介绍与CP关系以作品公开剧情为准，尽力避免主观臆断，数据可追溯。" },
  { icon: "ri-leaf-line", title: "持续更新", desc: "连载作品随剧情更新角色资料，人物关系线不断完善，保证图鉴新鲜度。" },
  { icon: "ri-team-line", title: "开放共建", desc: "鼓励读者投稿补充冷门角色与独家CP整理，优秀内容收录并标注来源。" },
  { icon: "ri-shield-star-line", title: "尊重版权", desc: "本站仅做资料整理与爱好者交流，所有内容版权归原作者所有。" },
];

const principles = [
  "只收录与韩国妖精漫画角色相关的真实内容，不做与主题无关的搬运",
  "女主颜值与人设、萌娘属性、CP组合均附作品出处，方便回查",
  "连载中的作品标注进度，避免把未定稿的人物关系写成既定事实",
  "内容优先服务读者检索，语言自然、通俗，不做关键词堆砌",
];

export default function About() {
  usePageMeta(
    "关于萌妖图鉴｜韩国妖精漫画角色资料整理与交流平台",
    "萌妖图鉴是韩国妖精漫画角色资料整理与爱好者交流平台，介绍我们的定位、发展理念与内容原则，欢迎投稿补充女主角色与CP组合资料。",
    jsonLd
  );
  useReveal();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="bg-background-100/60">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              <span className="text-foreground-700">关于我们</span>
            </nav>
            <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于萌妖图鉴</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              一本持续更新的韩国妖精漫画女主角色图鉴，把颜值、人设、萌娘属性与CP组合都整理好，让每位同好更快找到心动的那位女主。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
            <div className="reveal">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20reading%20and%20collecting%20desk%20with%20stacked%20webtoon%20books%2C%20cute%20fairy%20girl%20figurines%2C%20warm%20lamp%20light%2C%20sketchbook%20and%20notes%20about%20characters%2C%20soft%20warm%20cream%20and%20rose%20pastel%20palette%2C%20cozy%20hobbyist%20atmosphere%2C%20high%20quality%20illustration&width=900&height=680&seq=about-team&orientation=landscape"
                alt="萌妖图鉴团队整理角色资料的温馨场景"
                title="萌妖图鉴 角色整理日常"
                className="w-full rounded-3xl object-cover"
              />
            </div>
            <div>
              <SectionHeading
                eyebrow="品牌介绍"
                title="我们是谁"
                desc="萌妖图鉴诞生于一群『沉迷女主不可自拔』的妖精漫画同好。追番时总想系统看看某位女主的完整人设与CP线，却发现资料散落各处，于是我们决定自己动手，把它们一本本整理成图鉴。"
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {values.map((v) => (
                  <div key={v.title} className="reveal rounded-2xl border border-background-200 bg-background-50 p-4">
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className={`${v.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <h3 className="mt-3 text-sm font-semibold text-foreground-950">{v.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100/60">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
              <div>
                <SectionHeading
                  eyebrow="发展理念"
                  title="让角色检索变得简单而温暖"
                  desc="我们希望图鉴不只是一份冰冷的数据表，而是一本有温度的『女主之书』。从首页搜索、身份筛选到作品直达，让每位读者都能在三步之内找到想看的那位女主。"
                />
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  未来我们会逐步开放角色评分、CP话题与共建投稿，把图鉴做成一站式可查、可看、可聊的韩国妖精漫画角色社区。
                </p>
              </div>
              <div>
                <SectionHeading
                  eyebrow="内容原则"
                  title="我们坚持的整理标准"
                  desc="为了让每一条角色资料都经得起推敲，我们为内容维护定下了几条原则："
                />
                <ul className="space-y-3">
                  {principles.map((p) => (
                    <li key={p} className="reveal flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                        <i className="ri-check-line text-sm" aria-hidden="true"></i>
                      </span>
                      <p className="text-sm leading-relaxed text-foreground-700">{p}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="mx-auto max-w-7xl scroll-mt-20 px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <SectionHeading
                eyebrow="联系我们"
                title="投稿 / 纠错 / 合作"
                desc="有想补充的韩国妖精漫画女主资料、冷门萌娘人设或独家CP整理？欢迎通过表单告诉我们。你也可以直接给我们发邮件交流。"
              />
              <ul className="space-y-3 text-sm text-foreground-700">
                <li className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                    <i className="ri-mail-line" aria-hidden="true"></i>
                  </span>
                  contact@yaojing-tujian.example.com
                </li>
                <li className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className="ri-time-line" aria-hidden="true"></i>
                  </span>
                  内容审核与回复：通常 1-3 个工作日内
                </li>
                <li className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                    <i className="ri-question-line" aria-hidden="true"></i>
                  </span>
                  常见疑问可先查看 FAQ 页面
                </li>
              </ul>
            </div>
            <div className="lg:col-span-3 rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950">投稿与联系表单</h2>
              <p className="mt-2 mb-6 text-sm text-foreground-600">
                提交后我们会尽快审核你的内容，投稿被收录时会通过邮箱与你联系并标注来源。
              </p>
              <ContactForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}